import { CancellationReport } from "@packages/store/models/CancellationReport/CancellationReport";

export const sortReportByTeacher = (
  a: CancellationReport,
  b: CancellationReport
) => {
  return (a.teacher.lastName ?? "").localeCompare(b.teacher.lastName ?? "");
};
